interface BroadcastIdArgs {
  broadcastId: number;
}

export const broadcastPaths = {
  list: () => "/settings/emails/broadcast",
  edit: ({ broadcastId }: BroadcastIdArgs) =>
    `/settings/emails/broadcast/${broadcastId}/edit`,
  content: ({ broadcastId }: BroadcastIdArgs) =>
    `/settings/emails/broadcast/${broadcastId}/content`,
  listTemplates: ({ broadcastId }: BroadcastIdArgs) =>
    `/settings/emails/broadcast/${broadcastId}/content/templates`,
  previewTemplate: ({
    broadcastId,
    templateId,
  }: BroadcastIdArgs & { templateId: number }) =>
    `/settings/emails/broadcast/${broadcastId}/content/templates/${templateId}`,
  view: ({ broadcastId }: BroadcastIdArgs) =>
    `/settings/emails/broadcast/${broadcastId}/view`,
  viewAnalytics: ({ broadcastId }: BroadcastIdArgs) =>
    `/settings/emails/broadcast/${broadcastId}/view/analytics`,
} as const;
